import React from "react";

type Props = {
  children: React.ReactNode;
};

export function CouncilServicesLayout({ children }: Props): React.JSX.Element {
  return (
    <div>
      <div>{children}</div>
    </div>
  );
}
